(() => {
  const translations = new Map([
    ['Customer Reviews', 'Opinie klientów'],
    ['Review this product', 'Oceń ten produkt'],
    ['Share your thoughts with other customers', 'Podziel się swoją opinią z innymi klientami'],
    ['Write a review', 'Napisz opinię'],
    ['Write review', 'Napisz opinię'],
    ['All', 'Wszystkie'],
    ['Review with photos', 'Ze zdjęciami'],
    ['Review with videos', 'Z filmami'],
    ['All ratings', 'Wszystkie oceny'],
    ['Sort by', 'Sortuj'],
    ['Most helpful', 'Najbardziej pomocne'],
    ['Newest', 'Najnowsze'],
    ['Oldest', 'Najstarsze'],
    ['Highest rating', 'Najwyższa ocena'],
    ['Lowest rating', 'Najniższa ocena'],
    ['Photo/Video first', 'Najpierw ze zdjęciami'],
    ['Reply from ironlary', 'Odpowiedź sklepu ironlary'],
    ['Report', 'Zgłoś'],
    ['Report this review', 'Zgłoś tę opinię'],
    ['Rate this product', 'Oceń ten produkt'],
    ['Write your review', 'Napisz swoją opinię'],
    ['Add photos or videos', 'Dodaj zdjęcia lub filmy'],
    ['Add photo or video', 'Dodaj zdjęcie lub film'],
    ['Click to upload or drag and drop', 'Kliknij, aby przesłać, lub przeciągnij pliki'],
    ['Your name', 'Twoje imię'],
    ['Name display format', 'Sposób wyświetlania imienia'],
    ['Your name will appear as John Smith', 'Twoje imię będzie widoczne jako Jan Kowalski'],
    ['John Smith', 'Jan Kowalski'],
    ['Anonymous', 'Anonimowo'],
    ['Your email', 'Twój adres e-mail'],
    ['Your email is private and may be used to send you rewards or discounts', 'Twój adres e-mail pozostanie prywatny i może służyć do wysyłania nagród lub rabatów'],
    ['Submit review', 'Wyślij opinię'],
    ['Cancel', 'Anuluj'],
    ['Close', 'Zamknij'],
    ['Back', 'Wróć'],
    ['Done', 'Gotowe'],
    ['Ok', 'OK'],
    ['Review submitted successfully!', 'Opinia została przesłana pomyślnie!'],
    ['Thank you for spending time sharing your experience and leaving feedback, it will be very beneficial for other customers.', 'Dziękujemy za podzielenie się swoim doświadczeniem. Twoja opinia pomoże innym klientom w wyborze.'],
    ['Review in review', 'Opinia oczekuje na weryfikację'],
    ['Your review has been sent successfully and will be reviewed to ensure it meets our guidelines and standards. Please allow us some time to thoroughly assess your review.', 'Twoja opinia została wysłana i oczekuje na zatwierdzenie. Dziękujemy za cierpliwość.'],
    ['Thank you for leaving reviews', 'Dziękujemy za dodanie opinii'],
    ['*Please enter a valid email address!', '*Wpisz prawidłowy adres e-mail.'],
    ['*Please fill out this field', '*Uzupełnij to pole.'],
    ['*You have already uploaded this image', '*To zdjęcie zostało już przesłane.'],
    ['*Unable to upload the image. Please try again later', '*Nie udało się przesłać zdjęcia. Spróbuj ponownie później.'],
    ['No images uploaded yet!', 'Nie dodano jeszcze zdjęć.'],
    ['No videos uploaded yet!', 'Nie dodano jeszcze filmów.'],
    ['No medias uploaded yet!', 'Nie dodano jeszcze multimediów.'],
    ['No reviews yet. Any feedback? Let us know', 'Nie ma jeszcze opinii. Podziel się swoim doświadczeniem.'],
    ['Load more reviews', 'Wczytaj więcej opinii'],
    ['Click to rate', 'Kliknij, aby ocenić'],
    ['Review title', 'Tytuł opinii'],
    ['Type your name here', 'Wpisz swoje imię'],
    ['Tell other customers what you think about this product', 'Napisz innym klientom, co sądzisz o tym produkcie'],
    ['characters remaining', 'pozostało znaków']
  ]);

  const statusTranslations = new Map([
    ['Review submitted successfully!', 'Opinia została przesłana pomyślnie!'],
    ['Thank you for spending time sharing your experience and leaving feedback, it will be very beneficial for other customers.', 'Dziękujemy za podzielenie się swoim doświadczeniem. Twoja opinia pomoże innym klientom w wyborze.'],
    ['Review in review', 'Opinia oczekuje na weryfikację'],
    ['Your review has been sent successfully and will be reviewed to ensure it meets our guidelines and standards. Please allow us some time to thoroughly assess your review.', 'Twoja opinia została wysłana i oczekuje na zatwierdzenie. Dziękujemy za cierpliwość.'],
    ['Thank you for leaving reviews', 'Dziękujemy za dodanie opinii'],
    ['Done', 'Gotowe']
  ]);

  const trustshopLabels = {
    modal_success_review_title: 'Opinia została przesłana pomyślnie!',
    modal_success_review_subtitle: 'Dziękujemy za podzielenie się swoim doświadczeniem. Twoja opinia pomoże innym klientom w wyborze.',
    modal_success_review_button: 'OK',
    modal_pending_review_title: 'Opinia oczekuje na weryfikację',
    modal_pending_review_subtitle: 'Twoja opinia została wysłana i oczekuje na zatwierdzenie. Dziękujemy za cierpliwość.',
    modal_pending_review_button: 'Gotowe',
    modal_write_title_had_review: 'Dziękujemy za dodanie opinii',
    required_email: '*Wpisz prawidłowy adres e-mail.',
    required_input: '*Uzupełnij to pole.',
    media_upload_duplicate: '*To zdjęcie zostało już przesłane.',
    media_upload_fail: '*Nie udało się przesłać zdjęcia. Spróbuj ponownie później.',
    no_image: 'Nie dodano jeszcze zdjęć.',
    no_video: 'Nie dodano jeszcze filmów.',
    no_media: 'Nie dodano jeszcze multimediów.',
    no_review_text_no_review: 'Nie ma jeszcze opinii. Podziel się swoim doświadczeniem.',
    btn_load_more_review: 'Wczytaj więcej opinii',
    modal_review_text_click_to_rate: 'Kliknij, aby ocenić',
    modal_review_label_review_title: 'Tytuł opinii',
    modal_review_placeholder_customer_name: 'Wpisz swoje imię',
    modal_review_placeholder_review_content: 'Napisz innym klientom, co sądzisz o tym produkcie',
    modal_review_label_characters_remaining: 'pozostało znaków'
  };

  const patchTrustshopLabels = () => {
    const ts = window.__ts__;
    if (!ts) return;
    if (ts._rawLabelContent && typeof ts._rawLabelContent === 'object') {
      Object.assign(ts._rawLabelContent, trustshopLabels);
    }
    const filterKey = 'trustshop-widget_box_sort_filter';
    const filterSetting = ts.settings?.[filterKey];
    if (typeof filterSetting === 'string') {
      try {
        const filters = JSON.parse(filterSetting);
        if (Array.isArray(filters)) {
          ts.settings[filterKey] = JSON.stringify(filters.filter((item) => item !== 'review_with_videos'));
        }
      } catch (_) {
        // Trustshop may temporarily replace this value while loading.
      }
    }

    const key = 'trustshop-widget_box_label_content';
    const raw = ts.settings?.[key];
    if (typeof raw === 'string') {
      try {
        const parsed = JSON.parse(raw);
        Object.assign(parsed, trustshopLabels);
        ts.settings[key] = JSON.stringify(parsed);
      } catch (_) {
        // Trustshop may temporarily replace this value while loading.
      }
    }
  };

  const exactText = (value) => {
    const trimmed = value.trim();
    if (translations.has(trimmed)) return translations.get(trimmed);
    const reviews = trimmed.match(/^(\d+) Reviews?$/);
    if (reviews) {
      const count = Number(reviews[1]);
      return count === 1 ? '1 opinia' : count < 5 ? count + ' opinie' : count + ' opinii';
    }
    if (trimmed === 'Review on') return 'Opinia z dnia';
    if (trimmed.startsWith('Your name will appear as')) return 'Twoje imię będzie widoczne jako';
    return null;
  };

  const translateTextNodes = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const translated = exactText(node.nodeValue || '');
      if (translated) {
        const before = (node.nodeValue || '').match(/^\s*/)?.[0] || '';
        const after = (node.nodeValue || '').match(/\s*$/)?.[0] || '';
        node.nodeValue = before + translated + after;
      }
    }
  };

  const attributeTranslations = new Map([
    ['Filter by all', 'Filtruj: wszystkie'],
    ['Filter by review with photos', 'Filtruj: opinie ze zdjęciami'],
    ['Filter by review with videos', 'Filtruj: opinie z filmami'],
    ['Mark review as helpful', 'Oznacz opinię jako pomocną'],
    ['Report this review', 'Zgłoś tę opinię']
  ]);

  const translateStatusMessages = () => {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const trimmed = (node.nodeValue || '').trim();
      const translated = statusTranslations.get(trimmed);
      if (translated) {
        const before = (node.nodeValue || '').match(/^\s*/)?.[0] || '';
        const after = (node.nodeValue || '').match(/\s*$/)?.[0] || '';
        node.nodeValue = before + translated + after;
      }
    }
  };

  const removeVideoFilters = () => {
    document.querySelectorAll(
      "#trustshop-review [data-filter='review_with_videos'], .trustshop-filter--item:has(input[value='review_with_videos'])"
    ).forEach((element) => element.remove());
  };

  const localize = () => {
    patchTrustshopLabels();
    translateStatusMessages();
    removeVideoFilters();

    const roots = document.querySelectorAll(
      '#trustshop-review, #trustshop-form--review, [class*="trustshop"][class*="submitted"], [id*="trustshop"][id*="submitted"], [class*="trustshop"][class*="success"], [class*="trustshop"][class*="pending"], .trustshop-filter--popover, .trustshop-review-sort--options, [class*="trustshop"][class*="sort"][class*="popover"]'
    );
    for (const root of roots) {
      root.setAttribute('lang', 'pl');
      translateTextNodes(root);
    }

    for (const element of document.querySelectorAll('[aria-label], [title], [placeholder]')) {
      for (const attr of ['aria-label', 'title', 'placeholder']) {
        const value = element.getAttribute(attr);
        if (value && attributeTranslations.has(value)) {
          element.setAttribute(attr, attributeTranslations.get(value));
        }
        const translated = value ? exactText(value) : null;
        if (translated) element.setAttribute(attr, translated);
      }
    }
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      localize();
    });
  };

  patchTrustshopLabels();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once: true });
  } else {
    schedule();
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
